import styled from "styled-components";

export const PremiumPubBannerWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const PremiumPubBannerImage = styled.div`
  width: 100%;
  height: 370px;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    z-index: 2;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 52.93%,
      rgba(0, 0, 0, 0.225597) 60.95%,
      #000000 88.48%
    );

    pointer-events: none;
  }
`;

export const PremiumPubBannerSkeletonImage = styled.div`
  width: 100%;
  height: 370px;
  background: rgba(243, 243, 243, 1);
`;

export const PremiumPubBannerArrow = styled.div<{ isLeft: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  ${(p) => (p.isLeft ? `left: 16px;` : `right: 16px;`)}
`;

export const PremiumPubBannerInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: absolute;
  bottom: 0;
  padding: 0 16px 24px;
  z-index: 1;
  color: #fff;
  width: 100%;
`;

export const PremiumPubBannerPubInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: calc(100% - 100px);

  > .name {
    font-weight: 600;
    font-size: 16px;
  }
  > .address {
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

export const PremiumPubBannerInfoBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  > .box {
    height: 20px;
    border-radius: 16.67px;
    padding: 0 6px;
    background: #6436e7;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const PremiumPubBannerInfoHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  > .tag {
    font-weight: 600;
    font-size: 12px;
    height: 22px;
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 14px;
    padding: 4px 10px;
    background: linear-gradient(
      103.15deg,
      #6c36d6 -22.02%,
      #955fff 54.56%,
      #ccb2ff 102.58%
    );

    > img {
      width: 16px;
      height: 16px;
    }
  }
`;

export const PremiumPubBannerInfoBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const PremiumPubBannerInfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  > .item {
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 400;
    font-size: 14px;
  }
`;

export const PremiumPubBannerInfoPageWrapper = styled.div`
  width: 55px;
  text-align: center;
  height: 20px;
  border-radius: 10px;
  padding: 3px 8px;
  background: #ffffff33;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;

  > span {
    color: var(--Black-200, #b7b7b7);
  }
`;
